import * as classnames from 'classnames'
import compact from 'lodash-es/compact'
import * as React from 'react'

import * as styles from './highlighter.module.css'

const Highlighter = ({
  children,
  keywords,
  background,
  bold
}: {
  children: any
  keywords: string[]
  background?: boolean
  bold?: boolean
}): any => {
  const cssClass = classnames({
    [styles.background]: background,
    [styles.bold]: bold
  })

  const wrapper = (content: string, i: number): any => (
    <span key={i} className={cssClass}>
      {content}
    </span>
  )

  const matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g
  const keywordsLC = keywords.map(e =>
    e.replace(matchOperatorsRe, '').toLowerCase()
  )
  const regexInstance = RegExp
  const re = new regexInstance(`(${keywordsLC.join('|')})`, 'gi')

  const highlight = (child: any): any =>
    typeof child === 'string'
      ? child
          .split(re)
          .map((word: string, i: number): any =>
            keywordsLC.includes(word.toLowerCase()) ? wrapper(word, i) : word
          )
      : child

  return (
    <React.Fragment>
      {compact(keywordsLC).length
        ? React.Children.map(children, highlight)
        : children}
    </React.Fragment>
  )
}

export default Highlighter
